import logo from './logo.svg';
import './App.css';
import Header from './layouts/header';
import Home from './pages';
import Footer from './layouts/footer';
import Result from './pages/result';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HighSchool from './pages/HighSchool';

function App() {
  return (
    <div className="App">
      <ToastContainer position="top-center" />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/highschool" element={<HighSchool />} />
        <Route path="/result" element={<Result />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
